import { observer } from 'mobx-react';
import { bind, Modal, ModalHandle } from 'Mri.Web.Common';
import * as React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { AppStore } from '../../../Core/AppStore';

export interface IPowerOptionDropdownProps {
    sendActionAsync(powerAction: Mri.DisplaySettings.PowerStatus): Promise<void>;
}

@observer
export class PowerOptionDropdown extends React.Component<IPowerOptionDropdownProps> {
    public render() {
        return (
            <div className="d-inline-block">
                <UncontrolledButtonDropdown>
                    <DropdownToggle caret size="sm" color="primary">
                        Action
                    </DropdownToggle>

                    <DropdownMenu>
                        <DropdownItem onClick={() => this.sendPowerActionAsync(Mri.DisplaySettings.PowerStatus.Reboot)}>
                            Reboot
                        </DropdownItem>
                        <DropdownItem
                            onClick={() => this.sendPowerActionAsync(Mri.DisplaySettings.PowerStatus.PowerCycle)}
                        >
                            Power Cycle
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledButtonDropdown>

                <Modal
                    className="modal-sm"
                    title="Confirm Sending"
                    modalHandle={this.modalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    <div className="text-center">
                        Be aware, it could take up to 15 minutes for the display to finish booting and reestablish
                        connectivity.
                    </div>
                </Modal>
            </div>
        );
    }

    @bind
    private async sendPowerActionAsync(powerAction: Mri.DisplaySettings.PowerStatus) {
        if (await this.modalHandle.confirm()) {
            await this.props.sendActionAsync(powerAction);
        }
    }

    private modalHandle = new ModalHandle();
}
